import { render, staticRenderFns } from "./StandalonesGlobalList.vue?vue&type=template&id=8427af3c&scoped=true&"
import script from "./StandalonesGlobalList.vue?vue&type=script&lang=ts&"
export * from "./StandalonesGlobalList.vue?vue&type=script&lang=ts&"
import style0 from "./StandalonesGlobalList.vue?vue&type=style&index=0&id=8427af3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8427af3c",
  null
  
)

export default component.exports